import React from 'react';
import WarningBox from '../reusable/WarningBox';
import { formatRejectionDate } from './dateFormatting';

interface DataQcRejectedStateProps {
  rejections: Array<{
    district_data_qc_rejected_at: string;
    district_data_qc_rejected_by: string;
    district_data_qc_rejected_reason: string;
    district_data_qc_rejected_by_role: string;
  }>;
}

const DataQcRejectedState: React.FC<DataQcRejectedStateProps> = ({ rejections }) => {
  if (!rejections || rejections.length === 0) {
    return null;
  }

  const formatRejectionList = () => {
    return rejections.map((rejection, index) => {
      const formattedDate = formatRejectionDate(rejection.district_data_qc_rejected_at);
      const userDisplayName =
        rejection.district_data_qc_rejected_by_role === 'XQ_ADMIN'
          ? `${rejection.district_data_qc_rejected_by} (XQ Admin)`
          : rejection.district_data_qc_rejected_by;

      return (
        <li key={index}>
          Reported by {userDisplayName} on {formattedDate}
        </li>
      );
    });
  };

  return (
    <WarningBox title="Possible data quality issue reported">
      <ul>{formatRejectionList()}</ul>
    </WarningBox>
  );
};

export default DataQcRejectedState;
